import { useEffect, useState } from "react";
import {
  Flex,
  Button,
  Icon,
  Heading,
  Text,
  // Tooltip,
  Spinner,
} from "@chakra-ui/react";
import { columnsDesktop } from "../../columns/PatientTreatmentPlanColumns";
import { columnsMobile } from "../../columns/PatientTreatmentPlanColumnsMobile";
import {
  newBorder,
  textSecondary,
  white,
  primaryAlt,
  primary,
} from "../../../../../utils/colors";
import Table from "../../../../../components/shared/Table/index.js";
import { FaPlus } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import SidePanel from "../../../../../components/sidepanelNew/SidePanel";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteTreatmentPlan,
  duplicateTreatmentPlan,
} from "../../../../../actions/treatmentPlanActions";
import { TREATMENTPLAN_DETAILS_RESET } from "../../../../../constants/treatmentPlanConstants";
import { motion } from "framer-motion";
import { TbSearch } from "react-icons/tb";
import EditTreatmentPlanNew from "../../../treatmentplans/sidepanels/EditTreatmentPlanNew";
import { getPatientTreatmentPlansAction } from "../../../../../actions/patientActions";
import { useNavigate } from "react-router-dom";
import useThemeColors from "../../../../../hooks/useThemeColors";
import ConfirmDeleteModal from "../../../../../components/modals/ConfirmDeleteModal";
import ConfirmDuplicateModal from "../../../../../components/modals/ConfirmDuplicateModal";
import SearchInput from "../../../../../components/input/SearchInput.js";
import TableContainerWindowed from "../../../../../components/shared/Table/TableContainerWindowed.js";
import useIsMobile from "../../../../../hooks/useIsMobile.js";
import useCurrencySymbol from "../../../../../hooks/useCurrencySymbol.js";
import UserNoAccess from "../../../../../components/partials/UserNoAccess.js";
import DrawerNew from "../../../../../components/menu/DrawerNew.js";
import CardList from "../../../../../components/mobile/CardList.js";
// import TreatmentPlanCardMobile from "../../../treatmentplans/partials/TreatmentPlanCardMobile.js";
import PatientTreatmentPlanCardMobile from "../../../treatmentplans/partials/PatientTreatmentPlanCardMobile.js";

const PatientPlansNew = ({
  slug,
  patientId,
  buttonHandler,
  userInfo,
  currency,
  hasTreatmentPlansAccess,
  hasTreatmentPlansCreateAccess,
  hasTreatmentPlansEditAccess,
  hasTreatmentPlansDeleteAccess,
  hasTreatmentPlansDuplicateAccess,
  hasTreatmentPlansSendToPatientAccess,
}) => {
  //GENERAL
  const { t } = useTranslation();
  const translate = (key) => t(key);
  const navigate = useNavigate();
  const { whiteMode, backgroundLightMode, textPrimaryMode, newBorderMode } =
    useThemeColors();
  const isMobile = useIsMobile();

  // // ROLES
  // const isDoctor = useRoleCheck("employee_doctor");
  // const isAdmin = useRoleCheck("admin");

  // STATE

  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [sidePanelModalOpen, setSidePanelModalOpen] = useState(false);
  const [planId, setPlanId] = useState("");
  const [treatmentPlanID, setTreatmentPlanID] = useState("");
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  // const [sendEmailModalOpen, setSendEmailModalOpen] = useState(false);

  // SEARCH
  const [searchTerm, setSearchTerm] = useState("");
  // const debouncedSearchTerm = useDebounce(searchTerm, 600); // Use debounced value
  const normalizeText = (text) => {
    return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };
  const onChangeSearchTitle = (e) => {
    const normalizedText = normalizeText(e.target.value);
    setSearchTerm(normalizedText);
  };

  // PAGINATION
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const pageSizes = [5, 10, 25, 30];

  // SORTING
  const [sortField, setSortField] = useState("treatmentPlanID");
  const [sortOrder, setSortOrder] = useState("desc");

  const handleSortChange = (column) => {
    const newSortOrder =
      sortField === column && sortOrder === "asc" ? "desc" : "asc";

    if (sortField !== column || sortOrder !== newSortOrder) {
      // Only dispatch the action if sorting parameters change
      console.log(`Sorting ${column} in ${newSortOrder} order`);

      setSortField(column);
      setSortOrder(newSortOrder);
    }
  };

  // const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  // REDUX
  const dispatch = useDispatch();

  const getPatientTreatmentPlans = useSelector(
    (state) => state.getPatientTreatmentPlans
  );
  const { treatmentPlans, loading, error, pages, totalPlans } =
    getPatientTreatmentPlans;

  // HANDLERS
  const duplicateTreatmentPlanHandler = (treatmentPlanId) => {
    dispatch(duplicateTreatmentPlan(slug, treatmentPlanId));
  };

  const deleteTreatmentPlanHandler = (treatmentPlanId) => {
    dispatch(deleteTreatmentPlan(slug, treatmentPlanId));
  };

  const openSidePanelModalHandler = (id) => {
    setSidePanelModalOpen(true);
    setPlanId(id);
    document.body.style.overflow = "hidden";
  };

  const closeSidePanelModal = () => {
    setSidePanelModalOpen(false);
    setPlanId(null);
    dispatch({ type: TREATMENTPLAN_DETAILS_RESET });
    document.body.style.overflow = "auto";
  };

  // Fetch the treatment plans when page, sorting, or search term changes
  useEffect(() => {
    dispatch(
      getPatientTreatmentPlansAction(
        slug,
        patientId,
        page,
        pageSize,
        sortField,
        sortOrder,
        searchTerm,
        false
      )
    );
  }, [dispatch, patientId, pageSize, page, sortField, sortOrder, searchTerm]);

  // USE EFFECT

  const currencySymbol = useCurrencySymbol(currency);

  // console.log("trearmentPlans", treatmentPlans);
  // console.log("page", page);
  // console.log("pageSize", pageSize);
  // console.log("pages", pages);
  // console.log("totalPlans", totalPlans);
  // console.log("planId", planId);
  // console.log("treatmentPlanID", treatmentPlanID);

  // console.log("hasAccessToDelete", hasTreatmentPlansDeleteAccess);
  // console.log("hasAccessToDuplicate", hasTreatmentPlansDuplicateAccess);
  // console.log("hasAccessToEdit", hasTreatmentPlansEditAccess);

  return (
    <>
      {/* SIDEPANELS START */}
      {!isMobile ? (
        <SidePanel
          open={sidePanelModalOpen}
          close={closeSidePanelModal}
          title={t("treatmentPlan.editTreatmentPlan")}
          noBorder={true}
        >
          <Flex w="100%" bg={whiteMode} minW="800px" maxW="800px">
            <EditTreatmentPlanNew
              hasEditAccess={hasTreatmentPlansEditAccess}
              planId={planId}
              close={closeSidePanelModal}
              currentUser={userInfo}
              patientId={patientId}
              currency={currency}
              hasAccessSendToPatient={hasTreatmentPlansSendToPatientAccess}
            />
          </Flex>
        </SidePanel>
      ) : (
        <DrawerNew
          isOpen={sidePanelModalOpen}
          onClose={closeSidePanelModal}
          title={t("treatmentPlan.editTreatmentPlan")}
          size="full"
        >
          <EditTreatmentPlanNew
            hasEditAccess={hasTreatmentPlansEditAccess}
            planId={planId}
            close={closeSidePanelModal}
            currentUser={userInfo}
            patientId={patientId}
            currency={currency}
            hasAccessSendToPatient={hasTreatmentPlansSendToPatientAccess}
          />
        </DrawerNew>
      )}
      {/* SIDEPANELS END */}

      {/* MODALS START */}

      {showDeleteConfirmation && (
        <ConfirmDeleteModal
          hasAccessToDelete={hasTreatmentPlansDeleteAccess}
          noAccessPageName={t("noAccess.treatmentPlanDelete")}
          deleteTitle={t("treatmentPlan.deleteTreatmentPlanTitle")}
          deleteName={treatmentPlanID}
          // warningLabel={t("patient.deleteWarning")}
          isOpen={showDeleteConfirmation}
          onClose={() => setShowDeleteConfirmation(false)}
          confirmAction={() => {
            deleteTreatmentPlanHandler(planId);
            setShowDeleteConfirmation(false);
          }}
        />
      )}

      {showDuplicateModal && (
        <ConfirmDuplicateModal
          hasAccessToDuplicate={hasTreatmentPlansDuplicateAccess}
          noAccessPageName={t("noAccess.treatmentPlanDuplicate")}
          deleteTitle={t("treatmentPlan.duplicateTreatmentPlanTitle")}
          deleteName={treatmentPlanID}
          warningLabel={t("treatmentPlan.duplicateWarningText")}
          isOpen={showDuplicateModal}
          onClose={() => setShowDuplicateModal(false)}
          confirmAction={() => {
            duplicateTreatmentPlanHandler(planId);
            setShowDuplicateModal(false);
          }}
        />
      )}
      {/* MODALS END */}

      <Flex w="100%" direction="column" m="2rem 0 0">
        <Flex
          align="baseline"
          justify="space-between"
          m="0 0 0rem"
          p={["0rem 1.5rem", "0rem 0rem"]}
        >
          <Heading
            fontSize={["1rem", "1.125rem"]}
            color={textPrimaryMode}
            fontWeight="600"
            // p="0 0 0.75rem"
          >
            {t("patient.treatmentPlans")}
          </Heading>
          <Flex align="center" justify="flex-end" gap="0.5rem">
            <Button
              size="sm"
              h="2.25rem"
              fontSize="sm"
              border={`0px solid ${newBorderMode}`}
              bg={backgroundLightMode}
              color={textSecondary}
              borderRadius="10rem"
              onClick={() => setIsSearchOpen(!isSearchOpen)}
              _hover={{ bg: primaryAlt, color: white }}
            >
              <Icon
                as={TbSearch}
                fontSize="1rem"
                // mr="0.25rem"
              />
            </Button>

            <Button
              size="md"
              h="2.25rem"
              border={`0px solid ${newBorder}`}
              bg={textPrimaryMode}
              color={whiteMode}
              borderRadius="10rem"
              px="1.5rem"
              onClick={buttonHandler}
              _hover={{ bg: primaryAlt }}
              // isDisabled={!hasTreatmentPlansCreateAccess}
            >
              <Icon
                as={FaPlus}
                mr="0.25rem"
                h="0.65rem"
                w="0.65rem"
                opacity="1"
              />
              {/* <Icon as={FaPlus} fontSize="0.75rem" mr="0.25rem" /> */}
              <Text fontSize="0.85rem" fontWeight="600">
                {t("common.createNew")}
              </Text>
            </Button>
          </Flex>
        </Flex>
        <Flex
          w="100%"
          direction="column"
          p={["0rem 0rem 0 0", "0.5rem 0rem 0 0"]}
          bg={whiteMode}
          borderRadius="0rem"
        >
          <Flex
            w="100%"
            align="center"
            justify="space-between"
            p={["0.5rem 1.5rem 0rem", "0rem 0rem"]}
            bg={[backgroundLightMode, whiteMode]}
            borderTopLeftRadius="1rem"
            // mb="1rem"
            borderTopRightRadius="1rem"
          >
            {isSearchOpen && (
              <Flex
                as={motion.div}
                initial={{ opacity: 0, maxHeight: 0 }}
                animate={{ opacity: 1, maxHeight: "100%" }}
                exit={{ opacity: 0 }}
                w="100%"
              >
                <SearchInput
                  placeholder={t("treatmentPlan.searchSimple")}
                  onChange={onChangeSearchTitle}
                  searchName={searchTerm}
                  p="0"
                />
              </Flex>
            )}
          </Flex>

          {hasTreatmentPlansAccess ? (
            <Flex
              bg={whiteMode}
              w="100%"
              p={["0 0rem 0rem", "0 0rem 0rem"]}
              // border={
              //   treatmentPlans.length > 0
              //     ? `1px solid ${newBorderMode}`
              //     : `1px solid ${newBorderMode}`
              // }
              border={[
                `0px solid ${newBorderMode}`,
                `1px solid ${newBorderMode}`,
              ]}
              borderRadius={["0rem", "1rem"]}
              overflow="visible"
              direction="column"
              minH={treatmentPlans.length > 0 ? "auto" : "459px"}
            >
              {!isMobile ? (
                <>
                  {!loading ? (
                    <>
                      <TableContainerWindowed
                        isBorderRadius
                        columns={
                          isMobile
                            ? columnsMobile(
                                translate,
                                useThemeColors,
                                setPlanId,
                                setShowDeleteConfirmation,
                                setShowDuplicateModal,
                                openSidePanelModalHandler,
                                handleSortChange,
                                setTreatmentPlanID,
                                currencySymbol
                              )
                            : columnsDesktop(
                                translate,
                                useThemeColors,
                                setPlanId,
                                setShowDeleteConfirmation,
                                setShowDuplicateModal,
                                openSidePanelModalHandler,
                                handleSortChange,
                                setTreatmentPlanID,
                                currencySymbol
                              )
                        }
                        data={treatmentPlans}
                        loading={loading}
                        error={error}
                        navigateTo="/treatment-plans"
                        onRowClick={(planId) => {
                          openSidePanelModalHandler(planId);
                        }}
                        noItemsTitle={t("noItems.noPatientTreatmentPlans")}
                        noItemsDescription={t(
                          "noItems.noPatientTreatmentPlansText"
                        )}
                        noItemsButtonLabel={t("common.createNew")}
                        sortField={sortField}
                        sortOrder={sortOrder}
                        handleSortChange={handleSortChange}
                      />
                      {treatmentPlans.length > 0 && (
                        <Table.Pagination
                          loading={loading}
                          page={page}
                          pages={pages}
                          pageSize={pageSize}
                          pageSizes={pageSizes}
                          navigate={navigate}
                          setPage={setPage}
                          setPageSize={setPageSize}
                          totalCount={totalPlans}
                        />
                      )}
                    </>
                  ) : (
                    <Flex
                      w="100%"
                      justify="center"
                      align="center"
                      p="3rem 2rem"
                      minH="393px"
                    >
                      <Spinner size="lg" color={primary} />
                    </Flex>
                  )}
                </>
              ) : (
                <>
                  {!loading ? (
                    <>
                      <CardList
                        p="0rem 1.5rem 0rem"
                        isOnlySort
                        slug={slug}
                        data={treatmentPlans}
                        loading={loading}
                        sortField={sortField}
                        sortOrder={sortOrder}
                        onSortChange={(field, order) => {
                          setSortField(field);
                          setSortOrder(order);
                          setPage(1); // restart pagination
                        }}
                        page={page}
                        pages={pages}
                        pageSize={pageSize}
                        pageSizes={pageSizes}
                        setPage={setPage}
                        setPageSize={setPageSize}
                        totalCount={totalPlans}
                        navigate={navigate}
                        title={t("treatmentPlan.treatmentPlans")}
                        noItemsText={t("noItems.noTreatmentPlans")}
                        renderItem={(treatmentPlan) => (
                          <PatientTreatmentPlanCardMobile
                            key={treatmentPlan._id}
                            treatmentPlan={treatmentPlan}
                            currencySymbol={currencySymbol}
                            onRowClick={(planId) => {
                              // console.log("onrowclick planId", planId);
                              setPlanId(planId);
                              openSidePanelModalHandler(planId);
                            }}
                            // onDelete={() => {
                            //   setUserId(patient._id);
                            //   setShowDeleteConfirmation(true);
                            //   setPatientName(
                            //     `${patient.lastName} ${patient.firstName}`
                            //   );
                            // }}
                          />
                        )}
                        selectOptions={
                          <>
                            <option value="patientID-desc">
                              {t("sort.recentFirst")}
                            </option>
                            <option value="patientID-asc">
                              {t("sort.oldestFirst")}
                            </option>
                            <option value="lastName-asc">
                              {t("sort.nameAZ")}
                            </option>
                            <option value="lastName-desc">
                              {t("sort.nameZA")}
                            </option>
                          </>
                        }
                      />
                    </>
                  ) : (
                    <Flex
                      w="100%"
                      justify="center"
                      align="center"
                      p="3rem 2rem"
                      minH="393px"
                    >
                      <Spinner size="lg" color={primary} />
                    </Flex>
                  )}
                </>
              )}
            </Flex>
          ) : (
            <Flex
              w="100%"
              align="center"
              justify="center"
              p="3rem 2rem"
              minH="393px"
              border={`1px solid ${newBorderMode}`}
              borderRadius="1rem"
            >
              <UserNoAccess
                pageName={t("noAccess.treatmentPlans")}
                p="0rem 0 0"
              />
            </Flex>
          )}
        </Flex>
      </Flex>
    </>
  );
};

export default PatientPlansNew;
